import { useMemo, useState } from "react";
import hiring_pipeline from "../../../images/hiring_pipeline.png";
import Select from "react-select";
import { defaultDepartment, defaultManagers } from "../helper";
import { Table, Thead, Tr, Th, Tbody, Td } from "react-super-responsive-table";
import { useNavigate } from "react-router-dom";

const HiringPipeline = ({ departments, hiringManagers, pipelineData = [], userPrivilege }) => {
  const navigate = useNavigate();
  const [hiringPipelineState, setHiringPipelineState] = useState({
    department: "",
    hiringManager: "",
  });

  const hiringPipelineJobs = useMemo(
    () =>
      pipelineData
        .filter((job) => {
          if (hiringPipelineState.department) {
            return hiringPipelineState.department === job.department;
          } else {
            return true;
          }
        })
        .filter((job) => {
          if (hiringPipelineState.hiringManager) {
            return (
              hiringPipelineState.hiringManager === job.assignhiringmanager
            );
          } else {
            return true;
          }
        }),
    [pipelineData, hiringPipelineState]
  );

  return (
    <div className=" bg-white  py-3 items-center  rounded-divRadius shadow-sh">
      <div className="flex items-center justify-between w-full">
        <h2 className="font-semibold  relative  text-[16px] pl-4 leading-[18.75px] before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
          Active Hiring Pipeline
        </h2>
        <div className="flex justify-end space-x-3 pr-4">
          <Select
            placeholder="Select department"
            defaultValue={defaultDepartment}
            options={departments}
            onChange={(option) => {
              setHiringPipelineState((prev) => {
                return {
                  department: option.value,
                  hiringManager: prev.hiringManager,
                };
              });
            }}
            className="text-sm"
          ></Select>
          {userPrivilege !== "Hiring Manager" &&<Select
            className="text-sm"
            placeholder={<div>Select hiring manager</div>}
            defaultValue={defaultManagers}
            onChange={(option) => {
              setHiringPipelineState((prev) => {
                return {
                  department: prev.department,
                  hiringManager: option.value,
                  };
              });
            }}
            options={hiringManagers}
          ></Select>}
        </div>
      </div>
      <div className="bg-gray-300 h-[1px] mt-3 w-full"></div>
      {hiringPipelineJobs.length > 0 ? (
        <div className="px-4 h-[20rem] overflow-y-scroll">
          <Table className>
            <Thead className="text-sm top-0 bg-white sticky">
              <Tr className="font-semibold border-b ">
                <Th className="py-6 text-left  font-semibold">Job Title</Th>
                <Th className="font-semibold px-1">Applications</Th>
                <Th className="font-semibold px-1">Interview</Th>
                <Th className="font-semibold px-1">Offers</Th>
                <Th className="font-semibold px-1">Hired</Th>
                <Th className="font-semibold px-1">Rejected</Th>
                <Th className="font-semibold px-1">On-hold</Th>
              </Tr>
            </Thead>
            <Tbody>
              {hiringPipelineJobs.map((j) => {
                return (
                  <Tr className="border-b ">
                    <Td className="py-3 ">
                      <div>
                        {/* 
                            Original code had j["Job Title"] and j.profilename.
                            Backend returns j.job_title (which is profilename).
                            We'll just display job_title.
                        */}
                        <p
                          className="text-sm text-web-blue font-semibold cursor-pointer hover:underline"
                          onClick={() => {
                            if (j._id) {
                              navigate("/jobs/candidates/temp", {
                                state: { id: j._id },
                              });
                            }
                          }}
                        >
                          {j.job_title}
                        </p>
                      </div>
                    </Td>
                    <Td>
                      <p className="text-sm  py-3 text-center">
                        {j.total_apps}
                      </p>
                    </Td>
                    <Td>
                      <p className="text-sm  py-3 text-center">
                        {j.interview}
                      </p>
                    </Td>
                    <Td>
                      <p className="text-sm  py-3 text-center">
                        {j.offer}
                      </p>
                    </Td>
                    <Td>
                      <p className="text-sm  py-3 text-center">
                        {j.hired}
                      </p>
                    </Td>
                    <Td>
                      <p className="text-sm  py-3 text-center">
                        {j.rejected}
                      </p>
                    </Td>
                    <Td>
                      <p className="text-sm  py-3 text-center">
                        {j.on_hold}
                      </p>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </div>
      ) : (
        <div>
          <div className="flex h-[20rem] justify-center w-full items-center">
            <div>
              <img className="h-32" src={hiring_pipeline} alt=""></img>
              <p className="text-center mt-2 font-semibold">
                No data available
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HiringPipeline;
